export const ERR_REP = 42000  // 请求参数错误


// server errorCode
export const ERR_REP_NOT_LOGIN = 10018 // 未登录